<template>
  <v-data-table
    :headers="headers"
    :items="audienceData"
    :item-class= "getRowClasses"
    height="calc(70vh - 24px)"
    :items-per-page="-1"
    fixed-header
  >
    <!-- formate table headers -->
    <template v-for="h in headers" v-slot:[`header.${h.value}`]>
      <v-tooltip :key="h.value" bottom>
        <template v-slot:activator="{ on }">
            <span v-on="on" class="headerContent">{{h.text}}</span>
        </template>
        <TooltipDescription :title="h.text" :desc_2="h.desc"></TooltipDescription>
      </v-tooltip>
    </template>

    <!-- format name column -->
    <template v-for="C in titleColumns" v-slot:[`item.${C}`]="{item}">
      <div class="audienceNameCell" :key='C.value' v-if="item['type'].toUpperCase() !== 'AII'">
        {{ item[C] ? item[C].toLocaleString() : 'n/a' }}
      </div>
      <div class="audienceNameCell" :key='C.value' style="padding-left: 20%;" v-else>
        {{ item[C] }}
      </div>
    </template> 

    <!-- format string columns -->
    <template v-for="col in stringColumns" v-slot:[`item.${col}`]="{item}">
      <div class="textTableCell" :key='col.value'>
        {{ item[col] }}
      </div>
    </template> 

    <!-- format all plain numeric columns -->
    <template v-for="numCol in numericColumns" v-slot:[`item.${numCol}`]="{item}">
      <div :key='numCol.value' class='numericTableCell'>
        {{ item[numCol] ? item[numCol].toLocaleString('en-US', {maximumFractionDigits:0}) : 'n/a' }}
      </div>
    </template> 

    <!-- format all percentage columns -->
    <template v-for="pctgCol in percentageColumns" v-slot:[`item.${pctgCol}`]= "{item}">
      <div :key='pctgCol.value' class='numericTableCell'>
        {{
          item[pctgCol] ? item[pctgCol].toLocaleString('en-US', {maximumFractionDigits:2, minimumFractionDigits:0}) + '%' : 'n/a'
        }}
      </div>
    </template>
    <!-- format all percentage columns requiring multiplication by 100 -->
    <template v-for="pctgCol2 in percentageColumnsReqMult" v-slot:[`item.${pctgCol2}`]= "{item}">
      <div :key='pctgCol2.value' class='numericTableCell'>
        {{
          item[pctgCol2] ? (item[pctgCol2] * 100).toLocaleString('en-US', {maximumFractionDigits:2, minimumFractionDigits:0}) + '%' : 'n/a'
        }}
      </div>
    </template>
  </v-data-table>
</template>

<script>

import TooltipDescription from "@/components/Utility/TooltipDescription.vue";

function getRowClasses(item) {
  if (item.type.toUpperCase() == "P") {
    return 'highlightedRow';
  } 
}
export default {
    name: 'TalkTrendStatTable',
    props: [
      "audienceData"
    ],
    components: {
      TooltipDescription
    },
    methods: {
      getRowClasses
    },
    data: () => ({}),
    computed: {
      headers: function() {
        return [
          { "text": "Audience", "value": "name", "sortable": false, "desc": "The psychographic profile of the specified target segment."},
          { "text": "Demographic", "value": "demographic", "sortable": false, "desc": "The gender and age of the specified target segment."},
          { "text": "Market", "value": "market", "sortable": false, "desc": "Geography in the form of a city or region of the specified target segment."},
          { "text": "Total Population", "value": "population", "desc": "Unique amount of people within a specified target segment." },
          { "text": "Target Population", "value": "absolute_population", "desc": "Unique amount of people within a specified target segment." },
          { "text": "WSI", "value": "wom", "desc": "Word of Mouth Index"}
          // { "text": "Overlap %", "value": "overlap", "desc": "The percentage of the specified target segment that overlaps with the primary target audience." },
          // { "text": "WSI", "value": "wsi", "desc": "Word-of-mouth index indicating the likelihood that the specified target segment will have social interaction with the primary audience. 100 = status quo. Anything greater than 100 indicates a strong probability. Anything less than 100 indicated a low probability." },
          // { "text": "Unaware %", "value": "unaware", "desc": "The % of the specified target segment that is unaware of the brand's product/service." },
          // { "text": "Aware %", "value": "aware", "desc": "The % of the specified target segment that is aware and/or considering the purchase of the brand's product/service." },
          // { "text": "Converted %", "value": "converted", "desc": "The % of the specified target segment that has purchased the brand's product/service." },
          // { "text": "Conversion Rate", "value": "conversion_rate", "desc": "Conversion Rate" }
        ]
      },
      percentageColumns: function(){
        return [ 'overlap', 'unaware', 'aware', 'converted','conversion_rate'];
      },
      percentageColumnsReqMult: function(){
        return [];
      },
      numericColumns: function(){
        return [ 'population', 'absolute_population', 'wsi' , 'wom' ];
      },
      titleColumns: function(){
        console.log(this.title_cols)
        return ['name'];
      },
      stringColumns: function(){
        return ['demographic', 'market'];
      }
    }
}
</script>

<style>
  .highlightedRow {
    background-color: #0A8C4E80 ;
  }

  .highlightedRow:hover {
    background-color: #0A8C4E !important; ;
  }

  .v-data-table__wrapper > table > thead > tr > th {
    min-width: 130px;
  }

.text-start {
  font-weight: 600;
  font-family: 'Poppins';
  /* white-space: nowrap; */
    
  .headerContent {
    font-weight: 200 !important;
    /* white-space: nowrap; */
    text-overflow: ellipsis;
    display: inline-block;
    min-width: 80px;
    text-align: left;
    padding-left: 10%;
  }

  .audienceNameCell {
    text-wrap: auto;
    max-width: 400px;
    padding-left: 5%;
  }
  .numericTableCell {
    text-align: center;
    padding-right: 40%;
  }
  .textTableCell {
    text-align: left;
    padding-left: 20%;
    min-width: 250px;
  }
}

</style>
